<template>
  <svg
    width="27px"
    height="20px"
    viewBox="0 0 27 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Fill 1</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Home"
        transform="translate(-80.000000, -3823.000000)"
        fill="#999999"
      >
        <g id="Footer" transform="translate(80.000000, 3433.000000)">
          <g id="Group-16" transform="translate(0.000000, 387.000000)">
            <path
              d="M24.7380511,5.57268916 C24.2657351,4.30245049 23.0512491,3.46165383 21.6960511,3.46666667 L4.36271778,3.46666667 C2.97786331,3.46666667 1.74266571,4.33767183 1.27738444,5.64202249 C-0.425795825,10.4233185 -0.425794092,15.6460598 1.27738531,20.4273558 C1.75508764,21.7126667 2.99170311,22.5567593 4.36271778,22.5333541 L21.6960511,22.5333558 C23.0809064,22.5332596 24.3161058,21.6623732 24.7813844,20.3580225 C26.4845664,15.5767265 26.4845664,10.3539852 24.7813844,5.57268916 L24.7380511,5.57268916 Z M10.4293844,17.8100225 L10.4293844,8.19002249 L18.1340511,13.0000225 L10.4293844,17.8100225 Z"
              id="Fill-1"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon-youtube",
};
</script>

<style scoped lang="scss">
svg:hover path {
  fill: #666;
}
</style>
